export const downloadFile = async (
  url: string,
  filename: string,
  credentials: RequestCredentials = 'include',
) => {
  const response = await fetch(url, {
    credentials,
  });

  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();

  // Clean up the blob URL
  window.URL.revokeObjectURL(blobUrl);
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(blobUrl);
};

export const getFilenameFromContentDisposition = (
  disposition: string | null,
  fallback: string,
) => {
  if (!disposition) return fallback;

  const parts = disposition.split('filename=');
  if (parts.length <= 1) return fallback;

  return parts[1].replace(/"/g, '').trim() || fallback;
};
